import React, { useEffect } from "react";
import SearchInput from "../SearchInput/Input";
import {
  handleEventSearchTerm,
} from "../../utils/helpers";
import SkeletonResults from "./Skeleton";
import SkeletonFilter from "../Filters/Skeleton";

const NotFound = ({ search, isLoadingFilters, isLoading, isMobile, isError }) => {
  useEffect(() => {
    handleEventSearchTerm({
      action: "text",
      term: search,
      resultsCount: 0,
    });
  }, []);


  if (isLoading || isLoadingFilters)
    return (
      <div
        style={{
          display: "flex",
          maxWidth: "1200px",
          margin: "0 auto",
          marginTop: "30px",
        }}
      >
        {isMobile ? (
          <>
            <SkeletonResults />
            <SkeletonResults />
          </>
        ) : (
          <>
            <SkeletonFilter />
            <SkeletonResults />
          </>
        )}
      </div>
    );

  return (
    <div className="beon-showcase--search-container">
      {!isError ?
      <h2>Não encontramos resultados para sua pesquisa</h2>
      : <h2>Houve um problema, tente novamente no campo abaixo</h2>}
      <SearchInput onSubmit={false} showAnchor={false} noTerm={true} />
    </div>
  );
};

export default NotFound;
